import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePurchaseServiceOrderModel,
  EditPurchaseServiceOrderModel,
  EditPurchaseServiceOrderBatchModel,
  NotifyPurchaseServiceOrderModel,
} from '../../../models/purchase-reservation.model'

@Injectable({
  providedIn: 'root',
})
export class PurchaseServiceOrderService {
  private baseUrl = environment.baseUrl
  private resource = 'ComprasOrdemServico'

  constructor(private httpClient: HttpClient) {}

  public getByOsId(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ordem-servico/${osId}`,
    )
  }

  public create(
    model: CreatePurchaseServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editComprasOs(
    model: EditPurchaseServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit/compras-os`,
      model,
    )
  }

  public editComprasOsLote(
    model: EditPurchaseServiceOrderBatchModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit/compras-os/lote`,
      model,
    )
  }

  public notificar(
    model: NotifyPurchaseServiceOrderModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/notificar`,
      model,
    )
  }

  public getLinkAcessoWhatsApp(cosId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${cosId}/link-acesso-whatsapp`,
    )
  }

  public listConsultoresAtribuicao(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/consultores/listall`,
    )
  }
}
